import logo from "../../assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import { footerCollections } from "../../helpers/Footer";
import { Facebook, Instagram, Youtube } from "../../icons";
import { Tiktok } from "../../icons/Tiktok";
import { catalogs } from "../../helpers/Catalog";
import {
  Box,
  Button,
  CardMedia,
  Divider,
  Grid,
  Snackbar,
  SnackbarCloseReason,
  Typography,
  useTheme,
} from "@mui/material";
import { isValidEmail } from "../../utils/funtions";
import { useState } from "react";
import { supabase } from "../../services/supabase";

export const Footer = () => {
  const theme = useTheme();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const onRegisterEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValidEmail(email) || email === "") {
      setOpen(true);
      setMessage("Invalid email");
      return;
    }
    const { error } = await supabase
      .from("nikolay_subscribed")
      .insert([{ email }]);

    if (error) {
      setMessage("This email is already registered.");
      setOpen(true);
      return;
    }
    setMessage("Thank you for subscribing!");
    setOpen(true);
    setEmail("");
  };

  return (
    <Box
      width="100%"
      position="relative"
      left={0}
      bottom={0}
      zIndex={777}
      mt={25}
      display={location.pathname === "/search" ? "none" : "flex"}
      justifyContent="space-between"
      height="auto"
      flexDirection="column"
      sx={{ backgroundColor: theme.palette.customColor?.main }}
    >
      <Box
        position="absolute"
        zIndex={-1}
        width="100%"
        height="100%"
        top={0}
        left={0}
        boxShadow={`0px 0px 20px 30px ${theme.palette.customColor?.main}`}
      />

      <Grid
        mt={12}
        spacing={{ xs: 8, md: 15 }}
        container
        marginInline={{ xs: 5, md: 8 }}
      >
        <Grid
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          alignItems={{ xs: "center", md: "flex-start" }}
          position="relative"
          gap={4}
          size={{ xs: 12, md: 3 }}
        >
          <CardMedia
            component="img"
            src={logo}
            sx={{ maxWidth: 80, objectFit: "contain" }}
          />
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            maxWidth={500}
            variant="caption"
            sx={{ color: theme.palette.secondary[600] }}
          >
            Brings unique experiences in fashion and style. Authentic
            inspiration and exceptional quality. Beauty that transcends trends,
            with an experience that lasts.
          </Typography>

          <Link className="link-footer" to="/return-policy">
            Return Policy
          </Link>
        </Grid>

        <Divider
          sx={{
            display: { xs: "flex", md: "none" },
            flex: 1,
            borderColor: theme.palette.customColor?.light,
          }}
        />

        <Grid size={{ md: 2 }} display={{ xs: "none", md: "flex" }}></Grid>

        <Grid
          display={{ xs: "none", md: "flex" }}
          flexDirection="column"
          alignItems={{ xs: "center", md: "flex-start" }}
          gap={4}
          size={{ xs: 12, md: 2 }}
        >
          <Typography
            variant="body1"
            fontWeight={600}
            sx={{ color: theme.palette.secondary[700] }}
          >
            Collections
          </Typography>

          <Box
            display="flex"
            alignItems={{ xs: "center", md: "flex-start" }}
            gap={3}
            flexDirection="column"
          >
            {footerCollections.map((p) => (
              <Link
                key={p.id}
                to={`${p.to}/${p.toName}`}
                className="link-footer"
              >
                {p.item}
              </Link>
            ))}
          </Box>
        </Grid>

        <Grid
          display={{ xs: "none", md: "flex" }}
          flexDirection="column"
          alignItems={{ xs: "center", md: "flex-start" }}
          gap={4}
          size={{ xs: 12, md: 2 }}
        >
          <Typography
            variant="body1"
            fontWeight={600}
            sx={{ color: theme.palette.secondary[700] }}
          >
            Catalogs
          </Typography>

          <Box
            display={{ xs: "none", md: "flex" }}
            alignItems={{ xs: "center", md: "flex-start" }}
            gap={4}
            flexDirection="column"
          >
            {catalogs.map((c) => (
              <a
                key={c.id}
                href={c.document}
                className="link-footer"
                target="_blank"
                rel="noreferrer"
              >
                {c.name}
              </a>
            ))}
          </Box>
        </Grid>

        <Grid
          display="flex"
          flexDirection="column"
          alignItems={{ xs: "center", md: "flex-start" }}
          gap={4}
          size={{ xs: 12, md: 3 }}
        >
          <Typography
            variant="body1"
            fontWeight={600}
            sx={{ color: theme.palette.secondary[700] }}
          >
            Contact Us
          </Typography>

          <Box
            display="flex"
            alignItems={{ xs: "center", md: "flex-start" }}
            gap={4}
            flexDirection="column"
          >
            <a
              href="https://maps.app.goo.gl/D8uZTrSk3DTkJLGX9"
              rel="noreferrer"
              className="link-footer"
              target="_blank"
            >
              7003 Presidents Drive Unit 600, Orlando, FL, 32809
            </a>

            <a
              href="mailto:shop@nikolayorlando.com"
              rel="noreferrer"
              className="link-footer"
            >
              Email: shop@nikolayorlando.com
            </a>

            <a href="tel:+13212434480" className="link-footer">
              Phone: + 1 (321) 243-4480
            </a>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            gap={{ xs: 5, md: 2 }}
          >
            <a
              href="https://www.facebook.com/nikolayworld"
              className="btn-social"
              rel="noreferrer"
              target="_blank"
            >
              <Facebook sx={{ width: 17, height: 17 }} />
            </a>
            <a
              href="https://www.instagram.com/nikolayorlando"
              className="btn-social"
              rel="noreferrer"
              target="_blank"
            >
              <Instagram sx={{ width: 17, height: 17 }} />
            </a>
            <a
              href="https://www.youtube.com/@NIKOLAYGRISHKODANCEWEAR"
              className="btn-social"
              rel="noreferrer"
              target="_blank"
            >
              <Youtube sx={{ width: 17, height: 17 }} />
            </a>
            <a
              href="https://www.tiktok.com/@nikolayorlando"
              className="btn-social"
              rel="noreferrer"
              target="_blank"
            >
              <Tiktok sx={{ width: 17, height: 17 }} />
            </a>
          </Box>
        </Grid>

        <Grid
          display="flex"
          flexDirection="column"
          position="relative"
          gap={5}
          alignItems={{ xs: "center", md: "flex-start" }}
          size={12}
        >
          <Box marginInline={1}>
            <Typography
              textAlign={{ xs: "center", md: "left" }}
              variant="h6"
              color="secondary"
            >
              Newsletter
            </Typography>
            <Typography
              textAlign={{ xs: "center", md: "left" }}
              variant="caption"
              sx={{ color: theme.palette.secondary[500] }}
            >
              Sign-up for our news and offers
            </Typography>
          </Box>
          <Box
            component="form"
            onSubmit={onRegisterEmail}
            position="relative"
            bgcolor="white"
            borderRadius={2}
            gap={0.5}
            overflow="hidden"
            display="flex"
            alignItems="center"
          >
            <input
              type="text"
              name="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-subscribe"
              placeholder="Email address"
              required
            />
            <Button
              disabled={!email.length}
              type="submit"
              color="secondary"
              sx={{ m: 1, padding: "10px 25px" }}
              variant="contained"
              disableElevation
            >
              Subscribe
            </Button>
          </Box>

          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            onClose={handleClose}
            ContentProps={{
              sx: {
                boxShadow: "none",
                borderRadius: 2,
                backgroundColor: `${theme.palette.background.paper} !important`,
                backdropFilter: "saturate(180%) blur(20px)",
                color:
                  message === "Invalid email"
                    ? theme.palette.error.main
                    : message === "This email is already registered."
                    ? theme.palette.warning.main
                    : theme.palette.success.main,
              },
            }}
            open={open}
            message={message}
          />
        </Grid>
      </Grid>
      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        paddingBlock={5}
        mt={5}
        gap={6}
      >
        <Box width="100%" gap={1} display="flex" alignItems="center">
          <Divider
            sx={{ flex: 1, borderColor: theme.palette.customColor?.light }}
          />
          <Box
            width={10}
            height={10}
            borderRadius="100vmax"
            sx={{
              backgroundColor: theme.palette.customColor?.light,
              border: `solid 1px ${theme.palette.customColor?.dark}`,
            }}
          />
          <Divider
            sx={{ flex: 1, borderColor: theme.palette.customColor?.light }}
          />
        </Box>

        <Typography
          variant="body2"
          sx={{ fontSize: 13, color: theme.palette.secondary[500] }}
        >
          © 2025 Nikolay Orlando, Inc. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};
